import { ActionTypes } from '../actions/CompanyAdsActions';
// import Helpers         from 'app/utils/helpers/Helpers';

var initial_state = {};

var callables = {
	[ActionTypes.update_company_ads](state, action) {
		return Object.assign({}, state, action.company_ads);
	},

};

export default function(state = initial_state, action) {

	if (callables.hasOwnProperty(action.type)) {
		return callables[action.type](state, action);
	}

	return state;
};